import React from 'react';

import './paypal.less';

interface Props {
  isLoggedIn: boolean;
}

const ProgressBar = ({ isLoggedIn }: Props) => (
  <ol className="progressBar w-full md:max-w-md m-0">
    <li className="progressBar-stepContainer">
      <div className="progressBar-stepNumberWrapper">
        <span className="progressBar-stepNumber isFilled">1</span>
      </div>
      <span className="progressBar-stepTitle">Create Account</span>
    </li>
    <li className="progressBar-stepContainer">
      <div className="progressBar-stepNumberWrapper">
        <span className={`progressBar-stepNumber ${isLoggedIn && 'isFilled'}`}>
          2
        </span>
      </div>
      <span className="progressBar-stepTitle">Checkout</span>
    </li>
    <li className="progressBar-stepContainer">
      <div className="progressBar-stepNumberWrapper">
        <span className="progressBar-stepNumber">3</span>
      </div>
      <span className="progressBar-stepTitle">Customize</span>
    </li>
    <li className="progressBar-lineContainer" role="none" aria-hidden="true">
      <hr className="progressBar-line isFilled" />
      <hr className={`progressBar-line ${isLoggedIn && 'isFilled'}`} />
    </li>
  </ol>
);

export default ProgressBar;
